module.exports = __webpack_public_path__ + "img/Antonia&Stephan-18.325b6920.jpg";